export type TransferAction = 'send'

export const TRANSFER_ACTION_LABELS: Record<TransferAction, string> = {
  send: 'Send Tokens',
}

export const TRANSFER_ACTION_DESCRIPTIONS: Record<TransferAction, string> = {
  send: 'Send tokens from one address to another',
}
